import type { ContinueWatchingAsset } from '../../data';
import { WatchingStatus } from '../enums';
import { RequiredWatchedCatalogItem, processContinueWatchingAsset } from '../processing';
import { fetchWatchedList } from '../queries';

type KalturaWatchStatus = 'all' | 'done' | 'progress';

const categoryWatchingStatusToStatus: Record<KalturaWatchStatus, WatchingStatus> = {
  all: 'COMPLETED',
  done: 'COMPLETED',
  progress: 'IN_PROGRESS',
};

export async function fetchContinueWatching({
  types,
  watchingStatus,
  pageIndex,
  pageSize,
  daysSinceWatched,
}: {
  types: number[];
  watchingStatus: KalturaWatchStatus;
  pageIndex?: number;
  pageSize?: number;
  daysSinceWatched?: number;
}) {
  const { items, totalCount } = await fetchWatchedList({
    filter: {
      watchingStatus: categoryWatchingStatusToStatus[watchingStatus],
      daysSinceWatched,
    },
    catalogItem: {
      or: types.map((type) => ({
        catalogItem: {
          common: {
            type: {
              equals: type,
            },
          },
        },
      })),
    },
    page: {
      index: pageIndex,
      size: pageSize,
    },
  });

  const objects: ContinueWatchingAsset[] = [];

  for (let i = 0; i < items.length; i++) {
    const item = items[i];

    if (item.catalogItem) {
      objects.push(processContinueWatchingAsset(item as RequiredWatchedCatalogItem));
    }
  }

  return {
    objects,
    totalCount,
  };
}
